const smtPageDirectoryComponent = {
    section: {
        title: {
            // Section titles are text on the white body, so they take the
            // brand TEXT token rather than the mark itself. theme.500 is the
            // orange this fork inherited from PhotonQ and was never this
            // site's colour at all.
            color: {
                default: 'shared.text.brand',
                _dark: 'shared.text.brand'
            }
        }
    }
}

export default smtPageDirectoryComponent;